import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { Alert, Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import DropdownSelection from '../data/DropDown';
import ExportExcel from './ExportExcel';
import * as MySettings from '../store/Settings';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Records from '../store/Records';
import * as Studies from '../store/Studies';
import * as utility from '../data/Utility';
import * as elements from '../data/Elements';
import * as sortfilter from '../data/SortFilter';

const recordTableBodyId = "recordTableBody";
const resizeEventType = "resize";
const lblAction = "Billable Status";
const lblIsBillable = "isBillable";
const lblIsTBD = "isTBD";


class BillingInternal extends React.Component {
    constructor(props) {
        super(props);

		var billingColumnsUsedService = [
			{ fieldname: "patientCode", text: "Patient", sortOrder: 1010 },
			{ fieldname: "recordDateTime", text: "Record DateTime", sortOrder: 1020 },
			{ fieldname: "serviceType", text: "Service Type", sortOrder: 1030 },
			{ fieldname: "isScheduled", text: "Is Scheduled", sortOrder: 1040 },
			{ fieldname: "isSymptomatic", text: "Is Symptomatic", sortOrder: 1050 },
			{ fieldname: "isQaComplete", text: "Is QA Complete", sortOrder: 1060 },
			{ fieldname: "action", text: lblAction, sortOrder: 1020 },
		];

		var billingColumnsUsedItems = [
			{ fieldname: "qty", text: "Qty", sortOrder: 10 },
			{ fieldname: "code", text: "Item Code", sortOrder: 20 },
			{ fieldname: "description", text: "Description", sortOrder: 30 },
			{ fieldname: "isUorM", text: "U/M", sortOrder: 40 },
			{ fieldname: "price", text: "Price Each", sortOrder: 50 },
			{ fieldname: "amount", text: "Amount", sortOrder: 60 },
			{ fieldname: "action", text: lblAction, sortOrder: 70 },
		];


		/* create the values for the dropdown of the months */
		let arrPeriods = [];
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
		let dt = new Date();
		let selectedMonth = monthNames[dt.getMonth()].substr(0,3) + " " + dt.getFullYear();
		for ( let m = 0 ; m < 12 ; m++ ) {
			const nextMonth = monthNames[dt.getMonth()].substr(0,3) + " " + dt.getFullYear();
			arrPeriods.push(nextMonth);
			dt = new Date( dt.getFullYear(), dt.getMonth()-1, 15 );
		}

        this.state = {
			arrPeriods: arrPeriods,
			columnsUsedService: billingColumnsUsedService,
			columnsUsedItems: billingColumnsUsedItems,
			currentFilters: {},
			currentSortDirectionService: {},
			currentSortDirectionItems: {},
			currentSortingColumnService: '',
			currentSortingColumnItems: '',
			doExportToExcel: false,
			isBillableItem: {},
			isTbdItem: {},
			priceHolter: 280,
			price12lead: 30,
			priceEvent: 59,
            scroll: false,
			selectedMonth: selectedMonth,
            serviceType: "",
            studyId: props.studyId,
            studyName: props.studyName,
			doRefresh: props.doRefresh,
        };

		this.doRefreshFromDatabase();

        this.initialize = this.initialize.bind(this);
		this.cancelConfirmations = this.cancelConfirmations.bind(this);
        this.updateTableSize = this.updateTableSize.bind(this);
		this.calcTotalAmount = this.calcTotalAmount.bind(this);
		this.doFinalizeBill = this.doFinalizeBill.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        window.addEventListener(resizeEventType, this.updateTableSize);
        this.initialize(null);
    }

    componentWillUpdate(prevProps) {
		if ( this.state.doRefresh ) {
			this.props.recordsDispatch.resetAll();
			this.setState({ doRefresh: false });
		}
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    componentWillUnmount() {
        window.removeEventListener(resizeEventType, this.updateTableSize);
    }


    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        const recordsState = this.props.recordsState;
        const studyId = this.state.studyId;

        // Fetch record list, if necessary
        const needToFetch = (
			(
				((recordsState.all == null))
				&& ! recordsState.fetching
			)
			|| (studyId !== this.state.lastStudyId)
        );

		let isHcsRole = accountsState.authenticatedAccount && Accounts.isHcsRole(accountsState.authenticatedAccount.role);

		if ( isHcsRole && Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, needToFetch)) {
			if ( needToFetch && (studyId != null) && (studyId !== '') ) {
				(async () => {
					await this.props.recordsDispatch.getAllBillables(studyId);
				})().then(() => {
					const recordsState = this.props.recordsState;
					const records = recordsState.all;
					if ( records ) {
						let isBillableItem = {};
						let isTbdItem = {};
						for ( let i = 0 ; i < records.length ; i++ ) {
							isBillableItem[ records[i].id ] = (records[i].billableStatus === Records.recordBillableStatus.Billable) ? true : false;
							isTbdItem[ records[i].id ] = (records[i].billableStatus === Records.recordBillableStatus.TBD) ? true : false;
						}

						this.setState({
							isBillableItem: isBillableItem,
							isTbdItem: isTbdItem,
						});
					}

				 	this.setState({ billableItems: recordsState.billableItems, lastStudyId: studyId });

					(async () => {
						await this.props.studiesDispatch.get(studyId);
					})().then(() => {
						this.setState({ study: this.props.studiesState.study });
					});
				});
			}
		}

        this.updateTableSize();
    }

	calcTotalAmount() {
        const recordsState = this.props.recordsState;
		const records = recordsState.all;
		let amt = 0;

		const theState = this.state;

		if ( theState.billableItems && records && theState.study ) {

			/* calc the Billable Items */
			amt = theState.billableItems.reduce( function (amt, item) {
					return amt + item.price * item.qty;
					}, 0);

			amt += records.reduce( function (amt, rec) {
					if ( theState.isBillableItem[rec.id] === true ) {
						let price = 0;
						switch ( rec.serviceType ) {
							case Records.recordServiceTypes.holter:
								price = theState.study.priceHolter;
								break;
							case Records.recordServiceTypes.twelveLead:
								price = theState.study.price12lead;
								break;
							case Records.recordServiceTypes.event:
								price = theState.study.priceEvent;
								break;
							default:
								break;
						}
						return amt + price;
					} else {
						return amt + 0;
					}
					}, 0);
		}
		return amt.toFixed(2);
	}

	doExportToExcel() {
        const recordsState = this.props.recordsState;
		const records = recordsState.all;
		const theState = this.state;
		let dataToExport = { serviceRecords: null, billableItems: null };

		if ( ! records ) {
			return;
		}

		this.updateBillableStatuses();	/* do this in the background */

		dataToExport.serviceRecords = records.filter( rec => theState.isBillableItem[rec.id] === true );
		dataToExport.billableItems = theState.billableItems;

		this.setState({ doExportToExcel: true });

		/* Reset the Export to Excel button so that it can be clicked again */
		const that = this;
		setTimeout( () => { that.setState({ doExportToExcel: false }); }, 2000);
	}

	doFinalizeBill( isConfirmed ) {
		if ( isConfirmed ) {
			(async () => {
				await this.props.recordsDispatch.finalizeBill( { studyId: this.state.studyId, until: this.state.selectedMonth } );
			})().then(() => {
				this.setState({ redir: paths.selectStudy });
			});
		} else {
			(async () => {
				await this.updateBillableStatuses();
			})().then(() => {
				this.setState({
					showFinalizeBillConfirmation: true,
					error: false,
					message: ""
				});
			});
		}
	}

	async updateBillableStatuses() {
        const recordsState = this.props.recordsState;
		const records = recordsState.all;
		const theState = this.state;

		if ( ! theState.isBillableItem || ! records ) {
			return;
		}

		let serviceRecords = records;
		let billableItems = theState.billableItems;
		let isBillable = theState.isBillableItem;
		let isTbdItem = theState.isTbdItem;

		let dto = [];

		if ( serviceRecords ) {
			serviceRecords = serviceRecords.filter( r => r.billableStatus < Records.recordBillableStatus.Finalized );
			for ( var sr of serviceRecords ) {
				let b = (isTbdItem[sr.id] === true) ? Records.recordBillableStatus.TBD :
					((isBillable[sr.id]) ? Records.recordBillableStatus.Billable : Records.recordBillableStatus.NonBillable);
				sr.billableStatus = b;
				dto.push( { RecordId: sr.id, BillableStatus: b, isServiceRecord: true } );
			}
		}

		if ( billableItems ) {
			for ( var bi of billableItems ) {
				dto.push( { RecordId: bi.id, BillableStatus: Records.recordBillableStatus.Billable, isServiceRecord: false } );
			}
		}

		await this.props.recordsDispatch.updateBillableStatuses( dto );
	}


	doSelectStudy() {
		(async () => {
			await this.props.recordsDispatch.resetAll();
		})().then(() => {
			this.setState({ redir: paths.selectStudy });
		});
	}

	doRefreshFromDatabase() {
		this.setState({ lastStudyId: null });
	}

	doAddNewBill() {
		this.setState({
				itemId: '',
				lastStudyId: null,
				redir: paths.editBillableItem
			});
	}

	handleDropdownMonths( theChoices ) {
		let theChoice = theChoices[0];
		this.setState({ selectedMonth: theChoice });
		
		let dt = new Date(Date.parse(theChoice));
		dt = new Date(dt.getFullYear(), dt.getMonth()+1, 1);
		const nextMonth = (dt.getMonth()+1) + "/1/" + dt.getFullYear();

		this.setState({ currentFilters: {...this.state.currentFilters, "Record DateTime": '.before. ' + nextMonth } });
	}

	handleIsBillable = (strType, recordId, evt ) => {

		if ( strType === lblIsBillable ) {
			/* if turning Billable to true, then turn off TBD */
			if ( ! this.state.isBillableItem[recordId] ) {
				this.setState({ isTbdItem: {...this.state.isTbdItem, [recordId]: false} });
			}
			this.setState({ isBillableItem: {...this.state.isBillableItem, [recordId]: ! this.state.isBillableItem[ recordId ]} });
		} else {
			/* if turning TBD to true, then turn off Billable */
			if ( ! this.state.isTbdItem[recordId] ) {
				this.setState({ isBillableItem: {...this.state.isBillableItem, [recordId]: false} });
			}
			this.setState({ isTbdItem: {...this.state.isTbdItem, [recordId]: ! this.state.isTbdItem[ recordId ]} });
		}
	}
	
	requestItemDelete(itemId) {
		this.setState({
			showDeleteConfirmation: true,
			itemToDelete: itemId,
			error: false,
			message: ""
		});
	}
	
	cancelConfirmations() {
		this.setState({
			showFinalizeBillConfirmation: false,
			showDeleteConfirmation: false,
			itemToDelete: null,
            error: false,
			message: ""
		});
	}

	handleItemDelete = () => {
		const itemId = this.state.itemToDelete;

		(async () => {
			await this.props.recordsDispatch.deleteBillableItem(itemId);
		})().then(() => {
			const itemId = "deleted";
			this.setState({
				itemId: itemId,
				itemToDelete: null,
				showDeleteConfirmation: false,
				lastStudyId: null,
			});
			this.doRefreshFromDatabase();
		});
	}

	handleItemEdit = (itemId, evt) => {
		this.setState({
			redir: paths.editBillableItem,
			itemId: itemId,
			lastStudyId: null,
			studyId: this.state.studyId,
			studyName: this.state.studyName,
		});
		this.doRefreshFromDatabase();
	}

	handleItemDuplicate = (itemId, evt) => {
		this.setState({
			redir: paths.editBillableItem,
			itemId: itemId,
			lastStudyId: null,
			studyId: this.state.studyId,
			studyName: this.state.studyName,
		});

		(async () => {
			await this.props.recordsDispatch.duplicateBillableItem(itemId);
		})().then(() => {
			itemId = this.props.recordsState.billableItem;
			this.setState({
				redir: paths.editBillableItem,
				itemId: itemId,
				lastStudyId: null,
				studyId: this.state.studyId,
				studyName: this.state.studyName,
			});
		});
	}


	onSortChangeService = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirectionService;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirectionService: newCurrentSortDirection,
			currentSortingColumnService: currentColumn,
		});
	};


	onSortChangeItems = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirectionItems;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirectionItems: newCurrentSortDirection,
			currentSortingColumnItems: currentColumn,
		});
	};

	onClickAll = (e) => {
		let turnOn = false;
		const name = e.target.outerText;

		if ( name === "Select All" ) {
			turnOn = true;
		}
		if ( name === "Clear All" ) {
			turnOn = false;
		}

		const records = this.props.recordsState.all;
		if (records != null && records.map != null) {
			let rList = sortfilter.filterData( 
					[...records].map(record => {
						let tzOffset = record.timeZoneOffsetMinutes;
						if ( Math.abs(tzOffset) <= 16 ) {
							tzOffset *= 60;
						}
						return ({ ...record,
								isQaComplete: record.isQaComplete ? "Yes" : "No",
								isScheduled: record.isMdOverreadComplete ? "Yes" : "No",
								isSymptomatic: record.isMdOverreadRequired ? "Yes" : "No",
								recordDateTime: utility.formatDisplayDateTime(moment(record.recordDateTime).add(tzOffset,'m')),
								});
					}),
					this.state.currentFilters );
			let billies = this.state.isBillableItem;
			let tbds = this.state.isTbdItem;
			for ( let i = 0 ; i < rList.length ; i++ ) {
				billies[ rList[i].id ] = turnOn;
				if ( turnOn ) {
					tbds[ rList[i].id ] = false;
				}
			}
			this.setState({ isBillableItem: billies });
			this.setState({ isTbdItem: tbds });
		}
	};

	onFilterChange = (e) => {
		this.setState({ currentFilters: {...this.state.currentFilters, [e.target.name]: e.target.value } });
	};

	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = this.state.currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return(
			<sortfilter.ColHeader doActions={props.doActions} doAction={props.doAction} value={val} onClick={this.onClickAll.bind(this)} onChange={this.onFilterChange.bind(this)} sortDir={props.currentSortDirection} onSortChange={props.onSortChange} showFilter={props.showFilter} label={props.label} recordKey={props.recordKey} />
		);
	};


    render() {
        const accountsState = this.props.accountsState;
		let isHcsRole = accountsState.authenticatedAccount && Accounts.isHcsRole(accountsState.authenticatedAccount.role);
        if ( ! isHcsRole || ! Accounts.authenticatedAllRoles(accountsState) ) {
            return (
                <NotAuthenticated />
            );
        }

		if ( this.state.redir ) {
			return (
				<Redirect to={
						{
							pathname: this.state.redir,
							state: {
								returnPath: paths.billing,
								itemId: this.state.itemId,
								studyId: this.state.studyId,
								studyName: this.state.studyName,
							}
						}
					}
				/>
			);
		}

        var error = false;
        var message = "";
        var itemsList = null;
        var recordList = null;
		


        let records = this.props.recordsState.all;
        if (records != null && records.map != null) {
				let rowNum = 1;

				records = records.filter( r => r.billableStatus < Records.recordBillableStatus.Finalized );

				let rList = sortfilter.filterData(
					[...records].map(record => {
						let tzOffset = record.timeZoneOffsetMinutes;
						if ( Math.abs(tzOffset) <= 16 ) {
							tzOffset *= 60;
						}
						return ({ ...record,
							isQaComplete: record.isQaComplete ? "Yes" : "No",
							isScheduled: record.isMdOverreadComplete ? "Yes" : "No",
							isSymptomatic: record.isMdOverreadRequired ? "Yes" : "No",
							recordDateTime: utility.formatDisplayDateTime(moment(record.recordDateTime).add(tzOffset,'m')),
						});
					}),
					this.state.currentFilters
				);

				recordList = [...rList].sort( sortfilter.sortingDetails(this.state.currentSortingColumnService,this.state.currentSortDirectionService).fn ).map(record => {
					return (
						<tr key={record.id} id={record.id}>
							<th scope="row">{rowNum++}</th>
							{ this.state.columnsUsedService && this.state.columnsUsedService.map( col => {
									const isBillable = (this.state.isBillableItem[record.id] === true);
									const isTBD = (this.state.isTbdItem[record.id] === true);
									const el1 = elements.getCheckboxInput(
											"cbBillable_" + col.fieldname,
											isBillable,
											false,
											(evt) => this.handleIsBillable(lblIsBillable, record.id, evt),
											null, "Is Billable");
									const el2 = elements.getCheckboxInput(
											"cbTBD_" + col.fieldname,
											isTBD,
											false,
											(evt) => this.handleIsBillable(lblIsTBD, record.id, evt),
											null, "TBD");
									if ( col.text === lblAction ) {
										return ( <td key={record.id + "_" + col.fieldname} className="small-font leftAligned"> {el1} {el2} </td>);
									} else {
										return ( <td key={record.id + "_" + col.fieldname} className="small-font"> {record[ col.fieldname ]} </td>);
									}
								})
							}
						</tr>
					);
				});
		} else {
            error = true;
            message += " No service records found.";
        }


        if (this.state.billableItems != null && this.state.billableItems.map != null) {
				let rowNum = 1;

				let iList = sortfilter.filterData(
					[...this.state.billableItems].map(item => {
						return ({ ...item,
							price: '$' + item.price,
							amount: '$' + item.amount,
						});
					}),
					this.state.currentFilters
				);

				itemsList = [...iList].sort( sortfilter.sortingDetails(this.state.currentSortingColumnItems,this.state.currentSortDirectionItems).fn ).map(item => {
					return (
						<tr key={item.id} id={item.id}>
							<th scope="row">{rowNum++}</th>
							{ this.state.columnsUsedItems && this.state.columnsUsedItems.map( col => {
									const elDelete = <span
											className="billing-doAction billing-select-all"
											id={"btnEdit_" + col.fieldname}
											onClick={ (evt) => this.requestItemDelete(item.id, evt) }
										>
											Delete
										</span>
									;
									const elEdit = <span
											className="billing-doAction billing-select-all"
											id={"btnEdit_" + col.fieldname}
											onClick={ (evt) => this.handleItemEdit(item.id, evt) }
										>
											Edit
										</span>
									;
									const elDuplicate = <span
											className="billing-doAction billing-select-all"
											id={"btnEdit_" + col.fieldname}
											onClick={ (evt) => this.handleItemDuplicate(item.id, evt) }
										>
											Duplicate
										</span>
									;
									if ( col.text === lblAction ) {
										return ( <td key={item.id + "_" + col.fieldname} className="small-font center"> {elDelete} {elEdit} {elDuplicate} </td>);
									} else {
										return ( <td key={item.id + "_" + col.fieldname} className="small-font"> {item[ col.fieldname ]} </td>);
									}
								})
							}
						</tr>
					);
				});
		} else {
            error = true;
            message += " No non-service billables found.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        var tbodyClass = "billing-tbody-block centerOnly ";
        var theadClass = "billing-thead-block centerOnly ";
        if (this.state.scroll) {
            tbodyClass += " billing-tbody-scroll ";
            theadClass += " billing-thead-scroll ";
        }
        else {
            theadClass += "thead-no-scroll";
        }

		const classNameInput = "scheduler";

		const amt = this.calcTotalAmount();
		const strTotalAmount = amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

		const studyName = this.state.studyName;

		var deleteableItemCode = null;
		var deleteableItemDescription = null;
		if ( this.state.showDeleteConfirmation ) {
			const itemId = this.state.itemToDelete;
			const objItem = this.state.billableItems.find( item => item.id === itemId );
			deleteableItemCode = objItem && objItem.code;
			deleteableItemDescription = objItem && objItem.description;
		}

		var finalizingBillDescription = null;
		if ( this.state.showFinalizeBillConfirmation ) {
			const records = this.props.recordsState.all;
			if ( records ) {
				let serviceRecordsBillable = records.filter( r => r.billableStatus === Records.recordBillableStatus.Billable );
				let serviceRecordsNonBillable = records.filter( r => r.billableStatus === Records.recordBillableStatus.NonBillable );
				let serviceRecordsTBD = records.filter( r => r.billableStatus === Records.recordBillableStatus.TBD );
				finalizingBillDescription = <div style={{marginLeft: 30}}>
					<Row> <Col> Non-Service Billable Items: </Col> <Col> {this.state.billableItems && this.state.billableItems.length} </Col> </Row>
					<Row> <Col> Billable: </Col> <Col> {serviceRecordsBillable.length} </Col> </Row>
					<Row> <Col> Non-Billable: </Col> <Col> {serviceRecordsNonBillable.length} </Col> </Row>
					<Row> <Col> TBD: </Col> <Col> {serviceRecordsTBD.length} </Col> </Row>
					</div>
				;
			}
		}

		return (
			<div>
				<h1> Billing </h1>
				<span className="left_buttons">
					<Button className="button" id="btnSelectStudy" title="SelectStudy" onClick={this.doSelectStudy.bind(this)}> Select: <b>{studyName}</b> </Button>
					&nbsp; &nbsp;

					<DropdownSelection
							disabled={false}
							id="dropdown_Months"
							isCheckboxes={false}
							className={classNameInput}
							values={[this.state.selectedMonth]}
							selections={this.state.arrPeriods}
							onSelect={this.handleDropdownMonths.bind(this)}
							/>
				</span>
				<span className="right_buttons_top">
					<Button className="button" id="btnExportToExcel" title="ExportToExcel" onClick={this.doExportToExcel.bind(this)}> Export to Excel </Button>
					{ this.state.doExportToExcel &&
						<ExportExcel
							hideElement={true}
							reportMonth={this.state.selectedMonth}
							isBillable={this.state.isBillableItem}
							billableItems={this.state.billableItems}
							records={this.props.recordsState.all}
							study={this.state.study}
						/>
					}
					&nbsp; &nbsp;
					<Button className="button" id="btnFinalize" title="Finalize" onClick={(e) => this.doFinalizeBill(false)}> Finalize this Bill </Button>
				</span>
				<span className="billingTotalAmount">
					Total: <b> ${strTotalAmount} </b>
				</span>

				<br />

				{displayMessage && <Alert color={alertColor}>{message}</Alert>}

				<h5> Service Records </h5>
				<Table striped>
					<thead className={theadClass} id="recordTableHead">
						<tr>
							<th>#</th>
							{ this.state.columnsUsedService &&
								this.state.columnsUsedService.map( col => {
									return(
										<this.ColumnHeader
											showFilter={true}
											doActions={col.text===lblAction}
											key={col.text}
											label={col.text}
											recordKey={col.fieldname}
											currentSortDirection={this.state.currentSortDirectionService}
											onSortChange={this.onSortChangeService}
										/>
									);
								})
							}
						</tr>
					</thead>
					<tbody className={tbodyClass} id={recordTableBodyId}>
						{recordList}
					</tbody>
				</Table>

				<br />
				<br />

				<span className="right_buttons">
					<Button className="button" id="btnRefreshFromDatabase" title="RefreshFromDatabase" onClick={this.doRefreshFromDatabase.bind(this)}> Refresh From Database </Button>
					&nbsp; &nbsp;
					<Button className="button" id="btnAddNew" title="AddNew" onClick={this.doAddNewBill.bind(this)}> Add New ... </Button>
				</span>

				<h5> Equipment / Supplies / Misc </h5>
				<Table striped>
					<thead className={theadClass} id="recordTableHead">
						<tr>
							<th>#</th>
							{ this.state.columnsUsedItems && this.state.columnsUsedItems.map( col => { return( <this.ColumnHeader showFilter={false} doAction={col.text===lblAction} key={col.text} label={col.text} recordKey={col.fieldname} currentSortDirection={this.state.currentSortDirectionItems} onSortChange={this.onSortChangeItems} /> ); }) }
						</tr>
					</thead>
					<tbody className={tbodyClass} id={recordTableBodyId}>
						{itemsList}
					</tbody>
				</Table>

				<Modal isOpen={this.state.showDeleteConfirmation} toggle={this.cancelConfirmations} className="gap">
					<ModalHeader toggle={this.cancelConfirmations}> Delete Item Confirmation </ModalHeader>
						<ModalBody>
							About to delete item: {deleteableItemCode}
							<br />
							<br />
							{deleteableItemDescription}
							<br />
							<br />
							<b> Are you sure you want to delete this Billable Item? </b>
						</ModalBody>
					<ModalFooter>
						<Button color="primary" className="button" onClick={this.handleItemDelete}> Delete </Button>{' '}
						<Button color="secondary" onClick={this.cancelConfirmations}> Cancel </Button>
					</ModalFooter>
				</Modal>

				<Modal isOpen={this.state.showFinalizeBillConfirmation} toggle={this.cancelConfirmations} className="gap">
					<ModalHeader toggle={this.cancelConfirmations}> Finalize Bill Confirmation </ModalHeader>
						<ModalBody>
							About to Finalize this Bill.
							<br />
							<br />
							{finalizingBillDescription}
							<br />
							Be sure to Export your data before finalizing.
							<br />
							Only items marked TBD will appear again.
							<br />
							<br />
							<b> Are you sure you want to finalize this bill? </b>
						</ModalBody>
					<ModalFooter>
						<Button color="primary" className="button" onClick={(e) => this.doFinalizeBill(true)}> Finalize Bill </Button>{' '}
						<Button color="secondary" onClick={this.cancelConfirmations}> Cancel </Button>
					</ModalFooter>
				</Modal>


			</div>
		);
    }

    updateTableSize() {
        var adjustArray = null;
        const allRows = document.querySelectorAll("tr");
        var columns = null;
        var row = null;

        for (var i = 0; i < allRows.length; i++) {
            row = allRows[i];
            columns = row.children;
            if (row.id !== "") {
                this.updateTableSizeColumns(columns, adjustArray);
            }
            else {
                adjustArray = this.updateTableSizeColumns(columns, null);
            }
        }

        const recordTableBody = document.getElementById(recordTableBodyId);
        let scroll = this.state.scroll;
        const viewHeight = parseInt(document.body.clientHeight * 0.30, 10);   // * 0.30 to match className="tbody-scroll"
        if (
            recordTableBody != null &&
            recordTableBody.clientHeight >= viewHeight) {
            scroll = true;
        }
        if (
            this.state.scroll !== scroll) {
            this.setState({
                scroll: scroll
            });
        }
    }

    updateTableSizeColumns(columns, adjustArray) {
        var i = 0;
        const numColumns = columns.length;

        if (adjustArray == null) {
            adjustArray = [];
            var allColumnsWidth = 0;
            var columnWidth = 0;
            const recordTableBody = document.getElementById(recordTableBodyId);
            var rowCountColumn = null;
            const tableWidth = recordTableBody.clientWidth;

            if (recordTableBody.firstChild != null &&
                recordTableBody.firstChild.firstChild != null) {
                rowCountColumn = recordTableBody.firstChild.firstChild;
            }

            for (i = 0; i < numColumns; i++) {
                if (i === 0 && rowCountColumn != null) {
                    // Row count column will be larger in the body than header if >= 10
                    columnWidth = rowCountColumn.offsetWidth;
                } else {
                    columnWidth = columns[i].offsetWidth;
                }
                adjustArray.push(columnWidth);
                allColumnsWidth += columnWidth;
            }

            const widthAdjust = (tableWidth - allColumnsWidth) / 1;
            for (i = 1; i < numColumns; i++) {
                adjustArray[i] += widthAdjust;
            }
        }

        for (i = 0; i < numColumns; i++) {
            columns[i].width = adjustArray[i];
        }

        return adjustArray;
    }
}

const BillingConnect = connect(
    state => ({
        accountsState: state.accounts,
        recordsState: state.records,
        settingsState: state.settings,
        studiesState: state.studies
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch),
        settingsDispatch: bindActionCreators(MySettings.actionCreators, dispatch),
        studiesDispatch: bindActionCreators(Studies.actionCreators, dispatch)
    })
)(BillingInternal);

export default class Billing extends React.Component {
    render() {
        var studyId = null;
        var studyName = null;
        var doRefresh = false;

        const propsState = this.props.location.state;
        if (propsState != null) {
            if (propsState.doRefresh != null) {
                doRefresh = propsState.doRefresh;
            }
            if (propsState.studyId != null) {
                studyId = propsState.studyId;
            }
            if (propsState.studyName != null) {
                studyName = propsState.studyName;
            }
        }

        return (
            <ErrorBoundary>
                <BillingConnect studyId={studyId} studyName={studyName} doRefresh={doRefresh} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Billing.js